import { api } from '../../api/api';
import apiError from '../../api/api-error';

// initial state
const state = {
   rec:null
};

// getters
const getters = {
};

// actions
const actions = {
   WATER_MAIN_ZOOM_TO:(context, {water})=>{
      context.commit('MAP_FIT_BOUNDS', {bounds:state.rec.bounds,maxZoom:17});
   },
   WATER_MAIN_HIGHLIGHT:(context, {})=>{
      const feature = {
         styleLayer: 'water-mains',
         source:'scoutred',
         sourceLayer: 'water_mains',
         id: state.rec.id,
         properties:{
            geohash:state.rec.geohash
         }
      };
      context.commit('MAP_FEATURE_ACTIVE_SET', feature);
   },
   WATER_MAIN_HIGHLIGHT_CLEAR:(context, {})=>{
      context.commit('MAP_FEATURE_ACTIVE_SET', null);
   },
   WATER_MAIN_GET:(context, {id})=>{
      return new Promise((resolve, reject)=>{
         api.get('/api/water-mains/'+ id)
         .then((res)=>{
            context.commit('WATER_SET', {rec: res.data});
            resolve();
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('water main',error)});
            reject(apiError.message('water main',error));
         });
      });
   }
};

// mutations
const mutations = {
   WATER_SET:(state,{rec})=>{
      state.rec = rec;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/water-main.js